import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';

const TestimonialCard = ({
  quote,
  name,
  title,
  company,
  imageSrc,
  testimonial,
  delay = 0
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
      viewport={{ once: true, margin: "-100px" }}
      className="glass-card p-6 md:p-8 group"
      whileHover={{ 
        y: -5,
        boxShadow: '0 0 20px rgba(20, 187, 255, 0.3)'
      }}
    >
      <Quote size={36} className="text-primary-500/30 mb-4" />
      <p className="text-gray-300 italic mb-6">{quote}</p>
      <div className="flex items-center">
        <img 
          src={imageSrc} 
          alt={name} 
          className="w-12 h-12 rounded-full object-cover mr-4 ring-2 ring-primary-500/30 group-hover:ring-primary-500/70 transition-all duration-300"
        />
        <div>
          <h4 className="font-semibold text-white">{name}</h4>
          <p className="text-sm text-gray-400">{title}, {company}</p>
          <p className="text-sm text-gray-300">{testimonial}</p>
        </div>
      </div>
    </motion.div>
  );
}

export default TestimonialCard;
